import { Swiper, SwiperSlide } from 'swiper/react';
import './days-swiper.scss';
import { useEffect, useState } from 'react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// import required modules
import { Navigation, Mousewheel, Keyboard } from 'swiper';

export const DaysSwiper = ({ days, clickedDay }: any) => {

    useEffect(() => {
        if (Object.entries(days[0]).length === 0) {
            clickedDay(0);
        }
    });

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    return (
        <Swiper
            cssMode={true}
            navigation={windowWidth <= 530 ? false : true}
            mousewheel={true}
            keyboard={true}
            modules={[Navigation, Mousewheel, Keyboard]}
            className="swiper-general"
            spaceBetween={10}
            breakpoints={{
                // when window width is >= 640px
                300: {
                    slidesPerView: 2,
                },
                // when window width is >= 640px
                375: {
                    slidesPerView: 2.5,
                },
                // when window width is >= 768px
                425: {
                    slidesPerView: 4,
                },
                // when window width is >= 768px
                769: {
                    slidesPerView: 5,
                },
                // when window width is >= 768px
                1024: {
                    slidesPerView: 5.5,
                },
            }}
            onClick={(swiper) => { if (swiper.clickedIndex !== undefined) clickedDay(swiper.clickedIndex) }}
        >

            {days.map((day: any, index: number) => (

                <SwiperSlide key={index}>
                    <div className={`date-box ${day.active ? 'active' : ''} ${(days.length - 1) === index ? 'last-date-box' : ''}`}>
                        <h5>
                            <span>{index === 0 ? 'Hoy' : index === 1 ? 'Mañana' : day.weekDay}</span>
                            <br />
                            {day.monthDay} {day.month}
                        </h5>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};